export var PROJECTION_PROPERTIES = [
    'type',
    'clipAngle',
    'clipExtent',
    'center',
    'rotate',
    'precision',
    'coefficient',
    'distance',
    'fraction',
    'lobes',
    'parallel',
    'radius',
    'ratio',
    'spacing',
    'tilt'
];
//# sourceMappingURL=projection.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-lite/build/src/projection.js
// module id = 947
// module chunks = 0